import reducer from 'src/utils/redux/reducer';

export default flows => reducer({ flows });
